<template>
  <div>
    <div :class="$style.content">
      <div :class="$style.formWrapper">
        <div :class="$style.form" v-if="processError">
          <p :class="$style.formTitle">
            Hubo un error al cargar la subscripción. <br /><span
              style="font-size:12px"
              >Por favor, volver atrás y volver a intentar.</span
            >
          </p>
          <div class="login-form">
            <a-button type="primary" @click="goBack()"
              ><a-icon type="left" /> Volver
            </a-button>
          </div>
        </div>
        <div :class="$style.form" v-else>
          <a-form
            class="login-form"
            :form="form"
            @submit="handleSubmit"
            novalidate
          >
            <a-form-item has-feedback>
              <a-input
                name="cardnumber"
                autocomplete="cc-number"
                pattern="[0-9]*"
                ref="initial"
                placeholder="Número de Tarjeta"
                size="large"
                v-decorator="[
                  'cardNumber',
                  {
                    getValueFromEvent: formatCardNumber,
                    rules: [
                      {
                        required: true,
                        message: 'Por favor, ingrese el número de tarjeta.'
                      },
                      {
                        validator: validateCardNumber
                      }
                    ]
                  }
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="credit-card"
                  style="color: rgba(0,0,0,.25);"
                />
              </a-input>
            </a-form-item>

            <a-form-item has-feedback>
              <a-select
                name="cardtype"
                autocomplete="cc-type"
                size="large"
                @change="handleCardSelect"
                v-decorator="[
                  'cardType',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Por favor, ingrese un tipo de tarjeta.'
                      }
                    ]
                  }
                ]"
              >
                <span slot="placeholder"
                  ><a-icon type="credit-card" /> Tipo de Tarjeta</span
                >
                <!--<a-icon slot="suffixIcon" type="credit-card" />-->
                <a-select-opt-group>
                  <span slot="label"
                    ><a-icon type="credit-card" /> CREDITO</span
                  >
                  <a-select-option
                    v-for="item in creditPaymentCouriers"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}
                    <span
                      v-if="
                        item.paymentCouriersAccounts[0].ahora12 &&
                          showInstallments
                      "
                      style="font-size:11px; font-style: italic;color:#777"
                      ><a-icon type="forward"/> AHORA12
                      <img
                        style="vertical-align:-2.9px; margin-left:1px; margin-right:5px; width:15px;"
                        src="@/assets/ahora12-iso.svg"
                        width="15"
                    /></span>
                  </a-select-option>
                </a-select-opt-group>
                <a-select-opt-group>
                  <span slot="label"><a-icon type="credit-card" /> DEBITO</span>
                  <a-select-option
                    v-for="item in debitPaymentCouriers"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name
                    }}<span
                      v-if="item.debit"
                      style="font-size:11px; font-style: italic;color:#777"
                      ><a-icon type="forward" /> Débito
                    </span>
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-item>

            <a-form-item has-feedback>
              <a-input
                name="cardholder"
                autocomplete="cc-name"
                placeholder="Nombre y Apellido"
                size="large"
                v-decorator="[
                  'cardName',
                  {
                    rules: [
                      {
                        required: true,
                        message:
                          'Por favor, ingrese el nombre que figura en la tarjeta.'
                      }
                    ]
                  }
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0,0,0,.25);"
                />
              </a-input>
            </a-form-item>

            <a-form-item
              has-feedback
              v-if="
                $store.state.paymentForm.subtotal > amountDNIRequired &&
                  $store.state.paymentForm.gatewayId == 1
              "
            >
              <a-input
                name="cardholder"
                autocomplete="cc-ownerId"
                placeholder="DNI"
                size="large"
                v-decorator="[
                  'cardDNI',
                  {
                    rules: [
                      {
                        required: true,
                        message:
                          'Por favor, ingrese el dni del titular de la tarjeta.'
                      },
                      {
                        pattern: new RegExp(
                          /[0-9][0-9][0-9][0-9][0-9][0-9][0-9]([0-9])?([0-9])?$/
                        ),
                        message: 'El DNI debe ser un número de 7 a 9 dígitos.'
                      }
                    ]
                  }
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="idcard"
                  style="color: rgba(0,0,0,.25);"
                />
              </a-input>
            </a-form-item>

            <a-form-item has-feedback>
              <a-input
                name="expirationdate"
                autocomplete="cc-exp"
                pattern="[0-9]*"
                placeholder="Fecha de Expiración (MMAA)"
                size="large"
                v-decorator="[
                  'expirationDate',
                  {
                    getValueFromEvent: formatExpDate,
                    rules: [
                      {
                        required: true,
                        message: 'Por favor, ingrese la fecha de expiración.'
                      },
                      {
                        pattern: new RegExp(/(0[1-9]|10|11|12)\/[0-9]{2}$/),
                        message:
                          'Por favor ingrese 2 dígitos indicando el mes y dos dígitos indicando el año: MMYY'
                      }
                    ]
                  }
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="calendar"
                  style="color: rgba(0,0,0,.25);"
                />
              </a-input>
            </a-form-item>

            <a-form-item has-feedback>
              <a-input
                name="cvc2"
                autocomplete="cc-csc"
                pattern="[0-9]*"
                placeholder="Código de Seguridad (CVC)"
                size="large"
                v-decorator="[
                  'CVC',
                  {
                    getValueFromEvent: formatCVC,
                    rules: [
                      {
                        required: true,
                        message: 'Por favor, ingrese el código de seguridad.'
                      },
                      {
                        pattern: new RegExp(/^[0-9]{3,4}$/),
                        message:
                          'El código de seguridad deben ser 3 o 4 dígitos.'
                      }
                    ]
                  }
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0,0,0,.25);"
                />
              </a-input>
            </a-form-item>

            <a-form-item has-feedback v-if="showInstallments">
              <a-select
                name="installments"
                :disabled="installmentsInputDisabled"
                size="large"
                @change="handleInstallmentSelect"
                v-decorator="[
                  'installments',
                  {
                    initialValue: '0'
                    /*rules: [
                      {
                        required: true,
                        message: 'Por favor, elija el plan de pagos.'
                      }
                    ]*/
                  }
                ]"
              >
                <span slot="placeholder"
                  ><a-icon type="credit-card" /> {{ installmentsInputText }}
                </span>
                <a-select-option key="0" value="0"
                  >1 Pago sin Interés</a-select-option
                >
                <a-select-option
                  v-for="option in installmentsInputOptions"
                  :key="option.id"
                  :value="option.id"
                >
                  &nbsp; &nbsp; {{ option.numberOfPayments }} Cuotas
                  <span v-if="option.absorbFinanceCharge" class="sinInteres">
                    sin Interés</span
                  >
                  de
                  {{
                    new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS"
                    }).format(option.installmentPrice)
                  }}
                  <span style="font-size:12px; color:#777; font-style:italic;"
                    ><a-icon type="forward" /> Total:
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(option.totalPrice)
                    }}

                    <!--
                    ~ Interés:
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(option.totalPrice - subtotal)
                    }}--></span
                  >
                  <span
                    v-if="option.ahora12"
                    style="font-size:10px; font-style:italic"
                  >
                    <img
                      style="vertical-align:-2.9px; margin-left:3px; width:15px"
                      src="@/assets/ahora12-iso.svg"
                      width="15"
                    />
                    AHORA12</span
                  >
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="showAgreement" style="margin-top:-1rem;">
              <a-checkbox
                v-decorator="[
                  'agreement',
                  {
                    valuePropName: 'checked',
                    rules: [
                      {
                        required: true,
                        message:
                          'Por favor, aceptar los términos y condiciones para continuar.'
                      }
                    ]
                  }
                ]"
              >
                Acepto los Términos y Condiciones
              </a-checkbox>
            </a-form-item>

            <div
              v-if="showPrice"
              :class="$style.totalBox"
              style="margin-top:-1rem"
            >
              <span v-if="showInstallments">
                <!-- SHOW INSTALLMENTS -->
                <div v-if="showCFT">
                  <h2 style="font-size:30px; color:#999;">
                    CFT: {{ new Intl.NumberFormat("es-AR").format(CFT) }}%
                  </h2>
                </div>
                <a-row>
                  <a-col :span="11" style="">Subtotal</a-col>
                  <a-col :span="11" style="text-align:right">
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format($store.state.paymentForm.subtotal)
                    }}
                  </a-col>
                  <a-col :span="2"></a-col>
                </a-row>

                <a-row>
                  <a-col :span="11">Cargo Financiero</a-col>
                  <a-col :span="11" style="text-align:right">
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(financialCost)
                    }}
                  </a-col>
                  <a-col :span="2"></a-col>
                </a-row> </span
              ><!-- SHOW INSTALLMENTS -->
              <a-row style="margin-top:1rem">
                <a-col :span="8">
                  <h1>
                    Total
                  </h1>
                </a-col>
                <a-col :span="14" style="text-align:right">
                  <h1>
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(finalPrice)
                    }}
                    <span
                      v-if="$store.state.paymentForm.gatewayId == 1"
                      style="font-size: 16px"
                    >
                      ARS</span
                    >
                    <span
                      v-else-if="$store.state.paymentForm.gatewayId == 2"
                      style="font-size: 16px"
                    >
                      USD</span
                    >
                  </h1>
                </a-col>
                <a-col :span="2"></a-col>
              </a-row>
              <!--
              <a-row v-if="installment">
                <a-col :span="22" style="text-align:right">
                  <h1 style="font-size:15px; color:#555">
                    En {{ installment.numberOfPayments }} pagos de
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(installment.installmentPrice)
                    }}
                  </h1>
                </a-col>
                <a-col :span="2">&nbsp;</a-col>
              </a-row>
              -->
            </div>

            <div class="form-actions" v-if="showSubmit">
              <a-button
                v-if="submitEnabled"
                type="primary"
                html-type="submit"
                icon="lock"
                :class="$style.loginFormButton"
                :loading="submitLoading"
                :size="'large'"
                ><span style="padding-right: 5px">PAGAR</span
                >{{
                  new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS"
                  }).format(finalPrice)
                }}
                <span
                  v-if="$store.state.paymentForm.gatewayId == 1"
                  style="padding:0 10px 0 3px"
                  font-size="8px"
                >
                  ARS
                </span>
                <span
                  v-else-if="$store.state.paymentForm.gatewayId == 2"
                  style="padding:0 10px 0 3px"
                >
                  USD
                </span>
              </a-button>
              <a-button
                v-else
                type="primary"
                icon="check-circle"
                :class="[$style.loginFormButton, $style.greenBtn]"
                :size="'large'"
              >
                PAGADO</a-button
              >
              <!--
              <a-button
                type="primary"
                html-type="submit"
                icon="lock"
                :class="$style.loginFormButton"
                :loading="submitLoading"
                >{{
                  new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS"
                  }).format(finalPrice)
                }}
                PAGAR</a-button
              >-->

              <a-progress
                v-if="submitLoading"
                :status="loadingStatus"
                :percent="progressPercentage"
                :show-info="false"
                :type="'line'"
                :strokeWidth="5"
                :strokeLinecap="'square'"
              />
            </div>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import errors from "@/services/errors";
import utils from "@/services/utils";

export default {
  name: "paymentForm",
  props: {
    mode: {
      default: "1-step"
    },
    subtotal: {
      default: 0
    },
    showPrice: {
      default: true
    },
    showAgreement: {
      default: true
    },
    showInstallments: {
      default: true
    },
    showSubmit: {
      default: false
    },
    publicKey: { default: null }, //el publicKey es para poder pedir los installments identificando el account (no se pide el accountId para que no se puedan pedir los installments de otro account)
    //linkToken: { default: null }, //si no se envia el publicKey se debe enviar el linkToken
    //gatewayId: { default: null }, //el gatewayId es para poder identificar el gateway y mostrar el campo DNI si es requerido o no.
    customerCode: null,
    customerFirstName: null,
    customerLastName: null,
    customerPhone: null,
    customerEmail: null,
    costCenterId: null,
    businessUnitId: null,
    sellerUserId: null
  },
  data: function() {
    return {
      amountDNIRequired: process.env.VUE_APP_AMOUNT_CARD_DNI_REQUIRED,
      //subtotal: store.state.paymentForm.subtotal,
      form: this.$form.createForm(this),
      loading: false,
      submitLoading: false,
      //finalPrice: store.state.paymentForm.subtotal,
      financialCost: 0,
      CFT: 0,
      processError: false,
      paymentCouriers: [],
      installment: null,
      installmentOptions: null,
      installmentsInputOptions: [],
      installmentsInputDisabled: true,
      installmentsInputText: "Cuotas",
      installmentSelectedValue: null, //the select input value selected
      showCFT: false,
      cardSelected: null,
      cardSelectedValue: null, //the select input value selected
      cardKey: null,
      expDateKey: null,
      CVCKey: null,
      progressPercentage: 0,
      loadingStatus: "active",
      submitEnabled: true
      //fullscreen: false,
      //backgroundNumber: 1
    };
  },
  //components: {  },
  computed: {
    finalPrice() {
      return store.state.paymentForm.subtotal + this.financialCost;
    },
    creditPaymentCouriers() {
      if (this.paymentCouriers.length > 0) {
        return this.paymentCouriers.filter(pc => {
          return pc.debit == false;
        });
      } else return [];
    },
    debitPaymentCouriers() {
      if (this.paymentCouriers.length > 0) {
        return this.paymentCouriers.filter(pc => {
          return pc.debit == true;
        });
      } else return [];
    }
  },
  methods: {
    ...mapActions({
      setSubtotal: "paymentForm/setSubtotal",
      createCardToken: "paymentForm/createCardToken",
      getPaymentSettings: "paymentForm/getPaymentSettings",
      getInstallmentOptions: "paymentForm/getInstallmentOptions",
      getPaymentCouriers: "paymentForm/getPaymentCouriers",
      setPublicKey: "paymentForm/setPublicKey",
      setGatewayId: "paymentForm/setGatewayId",
      setShowPrice: "paymentForm/setShowPrice",
      setShowAgreement: "paymentForm/setShowAgreement",
      setShowInstallments: "paymentForm/setShowInstallments"
    }),
    disableSubmitLoaderWithSuccess() {
      this.progressPercentage = 100;
      this.loadingStatus = "success";
      this.submitLoading = false;
      this.submitEnabled = false;
    },
    disableSubmitLoaderWithError() {
      this.submitLoading = false;
      this.progressPercentage = 0;
      this.submitEnabled = true;
    },
    enableSubmitLoader() {
      this.submitLoading = true;
      this.incrementSubmitProgress();
    },
    incrementSubmitProgress() {
      if (this.progressPercentage < 99) {
        this.progressPercentage += 5;
        window.setTimeout(() => {
          this.incrementSubmitProgress();
        }, 30);
      } else {
        return;
      }
    },
    async updateMainSubtotal(subtotal) {
      this.setSubtotal(subtotal);
      if (!this.paymentCouriers || this.paymentCouriers.length == 0) {
        //todavia no se cargaron los couriers volver a llamar a settings
        const paymentSettings = await this.getPaymentSettings();
        this.paymentCouriers = paymentSettings.paymentCouriers;

        if (store.state.paymentForm.subtotal > 0 && this.showInstallments) {
          this.installmentOptions = paymentSettings.installmentOptions;
        }
      } //si ya se cargaron los payment couriers entonces solo buscar los installments con el nuevo amount.
      else if (this.showInstallments) {
        this.installmentOptions = await this.getInstallmentOptions({
          publicKey: store.state.paymentForm.publicKey,
          amount: store.state.paymentForm.subtotal
        });
      }
      if (this.cardSelectedValue) {
        this.handleCardSelect(this.cardSelectedValue);
      }
      if (this.installmentSelectedValue) {
        this.handleInstallmentSelect(this.installmentSelectedValue);
      }
      //this.handleCardSelect(this.cardSelectedValue);
    },
    formatCardNumber(e) {
      return utils.formatCardNumber(e, this.cardKey);
    },
    validateCardNumber(rule, val, callback) {
      utils.validateCardNumber(rule, val, callback);
    },
    formatExpDate(e) {
      return utils.formatExpDate(e, this.expDateKey);
    },
    validateExpDate(rule, val, callback) {
      utils.validateExpDate(rule, val, callback);
    },
    formatCVC(e) {
      return utils.formatCVC(e, this.CVCKey);
    },
    validateForm() {
      let validationError = false;
      this.form.validateFields((error, formInput) => {
        if (!error) {
          validationError = true;
        }
      });
      return validationError;
    },
    handleInstallmentSelect(val) {
      this.installmentSelectedValue = val;
      if (!val || val == 0 || !this.installmentOptions) {
        //if null means it wasn't selected yet
        //this.finalPrice = store.state.paymentForm.subtotal;
        this.installment = null;
        this.CFT = 0;
        this.financialCost = 0;
        this.showCFT = false;
      } else {
        //if 0 means 1 pago sin interés
        const installment = this.installmentOptions.filter(io => {
          return io.id == val;
        })[0];
        this.installment = installment;
        //this.finalPrice = installment.totalPrice;
        this.CFT = installment.CFT;
        this.financialCost =
          installment.totalPrice - store.state.paymentForm.subtotal;
        //this.showCFT = true;
      }
    },
    handleCardSelect(val) {
      this.cardSelectedValue = val;
      let cardTypeOptions;
      this.cardSelected = this.paymentCouriers.filter(pc => {
        return pc.id == val;
      })[0];

      console.log(`installmentOptions: ${this.installmentOptions}`);
      if (this.cardSelected.debit || !this.installmentOptions) {
        cardTypeOptions = null;
        this.installmentsInputDisabled = true;
        if (this.showInstallments)
          this.form.setFieldsValue({ installments: "0" });
        //this.finalPrice = store.state.paymentForm.subtotal;
        this.installment = null;
        this.CFT = 0;
        this.financialCost = 0;
        this.showCFT = false;
      } else {
        this.installmentsInputDisabled = false;
        //primero busca si hay planes de cuotas especificos para la marca seleccionada (cardType // visa, etc)
        cardTypeOptions = this.installmentOptions.filter(io => {
          if (io.paymentCourier) return io.paymentCourier.id == val;
          else return false;
        });

        //si no encuentra algo específico para la marca entonces carga las predeterminadas
        if (cardTypeOptions.length == 0) {
          cardTypeOptions = this.installmentOptions.filter(io => {
            return !io.paymentCourier;
          });
        }
      }
      this.installmentsInputOptions = cardTypeOptions;
    },
    async handleSubmit(e) {
      let validationError = true;
      let formData;
      let payload;
      this.submitLoading = true;
      if (e) e.preventDefault();

      this.form.validateFields((error, formInput) => {
        if (!error) {
          formData = formInput;
          validationError = false;
        } else {
          console.log("error", error);
        }
      });

      if (!validationError) {
        try {
          //console.log("Received values of form: ", formData);
          //this.submitLoading = true;
          const tempToken = await this.createCardToken({
            cardDetails: formData
          });
          //console.log(`tempToken: ${tempToken}`);
          let installment,
            numberOfPayments = null;
          if (this.installmentOptions) {
            installment = this.installmentOptions.filter(io => {
              return io.id == formData.installments;
            })[0];
            if (installment) numberOfPayments = installment.numberOfPayments;
          }

          //console.log(`subtotal: ${store.state.paymentForm.subtotal}`);
          if (this.mode == "2-step") {
            const cardNumberNoSpaces = formData.cardNumber.replace(/\s+/g, "");
            payload = {
              tempCardToken: tempToken || null,
              paymentCourierId: formData.cardType,
              cardName: formData.cardName,
              cardDNI: formData.cardDNI || null,
              bin: cardNumberNoSpaces.substring(0, 6),
              lastFourDigits: cardNumberNoSpaces.substring(
                cardNumberNoSpaces.length - 4
              ),
              expirationDate: formData.expirationDate,
              CVC: formData.CVC,
              installments: numberOfPayments,
              subtotal: store.state.paymentForm.subtotal,
              financialCost: this.financialCost,
              finalPrice: this.finalPrice
            };
            this.$emit("cardValidated", payload);
          }
          //this.submitLoading = false;
          /*
          this.$notification["success"]({
            message: "Tarjeta Validada. Procesando transacción..."
          });
          */
          return payload;
        } catch (err) {
          console.log(err);
          let description;
          if (err.message) description = err.message;
          else description = "Tarjeta Invalida. Por favor, intente denuevo.";
          this.submitLoading = false;
          this.$notification["warning"]({
            message: "Error",
            description: description
          });
        }
      } else {
        this.submitLoading = false;
        return false;
      }
    },
    goBack() {
      window.history.back();
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  async created() {
    this.setPublicKey(this.publicKey);
    this.setShowPrice(this.showPrice);
    this.setShowAgreement(this.showAgreement);
    this.setShowInstallments(this.showInstallments);
  },
  async mounted() {
    //this.$refs.initial.$el.children[1].focus(); //focus 1st input on page load.

    try {
      const x = 10;
      if (this.subtotal) {
        this.setSubtotal(this.subtotal); //en el subscription privado se carga el subtotal en el subscription y link de pagos publico no.
      }
      if (
        store.state.paymentForm.subtotal &&
        store.state.paymentForm.subtotal > 0
      ) {
        const paymentSettings = await this.getPaymentSettings();
        this.setGatewayId(paymentSettings.gatewayId);
        this.paymentCouriers = paymentSettings.paymentCouriers;
        if (this.showInstallments) {
          this.installmentOptions = paymentSettings.installmentOptions;
        }
      }
      //this.paymentCouriers = await this.getPaymentCouriers(this.publicKey);
      // if (store.state.paymentForm.subtotal > 0 && this.showInstallments)
      //   this.installmentOptions = await accountSettings.installmentOptions;
    } catch (error) {
      this.$notification["warning"]({
        message: "Error",
        description: error.message
      });
    }
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
.ant-select-dropdown {
  width: auto;
}
.ant-select-dropdown-menu {
  max-height: auto;
}
</style>

<style>
.ant-input {
  height: inherit !important;
}
.ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 32px !important;
}
.ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 32px !important;
}
::placeholder {
  /* WebKit browsers */
  color: red;
  opacity: 1 !important;
}
.sinInteres {
  font-weight: bold;
  color: #169fc7;
}
</style>
